import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import BusinessIcon from '@material-ui/icons/Business';
import { AdminRouteGuard } from '../auth/AdminRouteGuard';

const backofficeRouteRef = createRouteRef();

const backofficePage = PageBlueprint.make({
  params: {
    // PageBlueprint já monta splat interno; não use '/backoffice/*' (gera 404).
    path: '/backoffice',
    title: 'Backoffice',
    icon: <BusinessIcon fontSize="inherit" />,
    noHeader: true,
    routeRef: backofficeRouteRef,
    loader: async () => {
      const { BackofficePage } = await import('./BackofficePage');
      return (
        <AdminRouteGuard>
          <BackofficePage />
        </AdminRouteGuard>
      );
    },
  },
});

export const backofficePlugin = createFrontendPlugin({
  pluginId: 'backoffice',
  title: 'Backoffice',
  icon: <BusinessIcon fontSize="inherit" />,
  routes: {
    root: backofficeRouteRef,
  },
  extensions: [backofficePage],
});
